import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import Pagination from "react-js-pagination";
import { Button, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faPlus } from "@fortawesome/free-solid-svg-icons";
import PageHeader from "../../components/common/PageHeader";
import FilterDropdown from "../../components/common/FilterDropdown";
import LocationItem from "./LocationItem";
import LocationFormModal from "./LocationFormModal";
import NoRecord from "../../components/common/NoRecord";
import { pagination, statusOptions } from "../../utils/constants";
import { getItems, add, update } from '../../context/actions/location';
import { set_param_first } from '../../context/actions/general';
import {tempAction} from "../../context/actions/tempAction"
const Location = () => {
  const history = useHistory()

  const role = useSelector((state) => state?.user?.user?.roles?.role?.roleName);
  const [userRole, setUserRole] = useState(role);

  useEffect(() => {
    let isMounted = true; // Add a boolean flag to track component mount state

    if (!userRole?.toLowerCase()?.includes("admin")) {
      history.push("/unauthorized");
    }

    return () => {
      isMounted = false; // Set the flag to false when the component unmounts
    };
  }, [userRole, history]);
  const dispatch = useDispatch();
  //state manage to 
  const [title, setTitle] = useState('Add New Work Group');
  const [page, setPage] = useState(1);
  let [payload, setPayload] = useState({ page: 1, limit: pagination.limit });
  const status = false;
  const [lodder, setLodder] = useState(false);

  const [resPayload, setResPayload] = useState();

  const [detail, setDetail] = useState();
  const [isAddModelOpen, setIsModelOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);
  // methos call for add new item and set flag and reset form
  const handleAddLocation = () => {
    setDetail('')
    setTitle('Add New Work Group')
    setIsModelOpen(true);
  };


  // methos call for edit item and set flag 
  const handleEditLocation = () => {
    setDetail('')
    setTitle('Edit Work Group')
    setIsModelOpen(true);
  };



  //method call to open/close modal
  const toggle = () => setIsModelOpen(!isAddModelOpen);

  // whenever any status will update to get location items
  useEffect(() => {
    _getItems()
   
  }, []);

  /**
   * @description method call to modal for adding new location
   */
  const _getItems = async () => {
    dispatch(getItems(payload, (res) => { setResPayload(res) }))
  }

  /**
   * @description method call to modal for adding new location
   * @param {object} params accepting params name,address, phone and email
   */
  const _submit = async (params, callback) => {
    console.log(params)
    setDisabled(true);
    setLodder(true)
    dispatch(add(params, (res) => { setDisabled(false); setLodder(false); if (res) { toggle(); _getItems(); callback(); } }))
  }

  /**
   * @description method call to modal for update existing records
   * @param {object} params for params name,address, phone and email
   * @param {string} id record Id
   */
  const _update = async (params, id, callback) => {
    setDisabled(true);
    setLodder(true)
    dispatch(update(params, id, (res) => { setDisabled(false); setLodder(false); if (res) { toggle(); _getItems(); callback(); } }))
  }


  /**
  * @description method call to modal for update existing records
  * @param {object} params for params name,address, phone and email
  * @param {string} id record Id
  */
  const _deleteAndRestore = async (status, id) => {
    let body = new FormData();
    body.append("deleted", status);
    dispatch(update(body, id, (res) => { if (res) _getItems() }))
  }

  /**
 * @description method call to update active page and call API to get respective records
 * @param {Number} activePage accepting number
 */
  const _handlePageChange = async (activePage) => {
    payload = { ...payload, page: activePage }
    setPayload(setPayload)
    setPage(activePage)
    dispatch(getItems(payload, (res) => { setResPayload(res) }))
  }
  /**
     * @description method call to update active page and call API to get respective que records
     * @param {Boolean} val accepting number
     */
  const _handleFilter = async (val) => {
    payload = { ...payload, deleted: val }
    setPayload(payload)
    dispatch(getItems(payload, (res) => { setResPayload(res) }))
  }

  const _viewInfo = async (id) => {
    dispatch(set_param_first(id))
    history.push('/workgroup-detail')
  }


  return (
    <>
      <div className="page-wrapper">
        <PageHeader className="with-btn multiple filters-header">
          <div className="left-col d-inline-flex align-items-center">
            <Button color="link" className="backBtn" onClick={() => {
              history.push("/dashboard");
            }} >
              <FontAwesomeIcon icon={faAngleLeft} />
            </Button>
            Work Group
          </div>
          <div className="right-col ms-auto btns-col d-inline-flex align-items-center">
            {/* <SearchBlock2 /> */}
            <div className="drodpdown-col d-flex align-items-center">
              {/* <SortFilterDropdown /> */}
              <FilterDropdown options={statusOptions} val={status} handleVal={(val) => _handleFilter(val)} />
            </div>
            <div className="btn-wrapper">
              <Button
                color="secondary"
                className="add-btn"
                onClick={handleAddLocation}
              >
                <span>
                  <FontAwesomeIcon icon={faPlus} />
                </span>
                Add New Work Group
              </Button>
            </div>
          </div>
        </PageHeader>
        <div className="inner-wrapper position-relative">
          <div className="location-wrapper">
            {/* <LocationFormModal /> */}
            <Row>
              {resPayload?.docs?.map((item, inx) => {
                return (
                  <Col lg="6" key={inx}>
                    <LocationItem item={item} _editItem={(itm) => { handleEditLocation(); setDetail(itm) }} _deleteAndRestore={_deleteAndRestore} _viewInfo={_viewInfo} />
                  </Col>
                );
              })}
              {resPayload?.docs?.length === 0 && <NoRecord />}
            </Row>
          </div>
        </div>
      </div>

      {resPayload?.docs?.length !== 0 && <Pagination
        innerClass="pagination justify-content-end pb-10 mt-auto"
        itemClass="page-item"
        linkClass="page-link"
        prevPageText="Previous"
        nextPageText="Next"
        firstPageText="First"
        lastPageText="Last"
        activePage={page}
        itemsCountPerPage={pagination.limit}
        totalItemsCount={resPayload?.totalDocs}
        onChange={(activePage) => {
          _handlePageChange(activePage)
        }}
      />}
      <LocationFormModal
        title={title}
        showModel={isAddModelOpen}
        _toggle={toggle}
        _submit={_submit}
        _update={_update}
        _detail={detail}
        disabled={disabled}
        lodder={lodder}
      />
    </>
  );
};
export default Location;
